import React from 'react'
import { asTrackedClickable } from '@web/o11y/analytics/tracked_clickable'
import { LoadingSpinner } from '@web/ui-platform/loading_spinner'
import classNames from 'classnames'

import { LazyInput__DEPRECATED } from 'shared/components/lazy_input/lazy_input'

import * as authViewStyles from 'shared/auth/views/auth_view/auth_view.css'
import * as styles from './landing_form.css'

interface BrandButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean
  fullWidth?: boolean
  use?: 'standard' | 'hollow'
  autoHeight?: boolean
}

/**
 * @deprecated If you need to use the BrandButton component for elements that will show up in Auth and Landing pages,
 * then please use the BrandButton component from `shared/components/brand/brand_buttons.tsx` instead.
 *
 * If you want to use something that looks like the old BrandButton, then you may want to roll up your own button for this.
 * For inspiration, you can look at `NuxDynamicPreviewButton` in `figma_app/views/nux/components/nux_dynamic_preview_button.tsx`
 * which was a button converted from the old BrandButton
 */
export class DEPRECATED_BrandButton extends React.Component<BrandButtonProps, {}> {
  public static displayName = 'Button'

  static defaultProps = {
    fullWidth: true,
  }

  public override render() {
    const className = classNames(
      authViewStyles.brandButton,
      {
        [authViewStyles.fullWidth]: this.props.fullWidth,
        [styles.hollowButton]: this.props.use === 'hollow',
        [styles.autoHeight]: this.props.autoHeight,
      },
      this.props.className,
    )

    const childProps = { ...this.props, className }
    delete childProps.loading
    delete childProps.fullWidth
    delete childProps.autoHeight

    return (
      <button {...childProps} disabled={this.props.disabled || this.props.loading}>
        {this.props.loading ? (
          <div className={styles.loadingIconCentered}>
            <LoadingSpinner />
          </div>
        ) : (
          this.props.children
        )}
      </button>
    )
  }
}

/**
 * @deprecated If you need to use the BrandButton component for elements that will show up in Auth and Landing pages,
 * then please use the BrandButton component from `shared/components/brand/brand_buttons.tsx` instead.
 *
 * If you want to use something that looks like the old BrandButton, then you may want to roll up your own button for this.
 * For inspiration, you can look at `NuxDynamicPreviewButton` in `figma_app/views/nux/components/nux_dynamic_preview_button.tsx`
 * which was a button converted from the old BrandButton
 */
export const DEPRECATED_BrandButtonTracked = asTrackedClickable(DEPRECATED_BrandButton)

export class TextInput extends React.Component<any, {}> {
  public static displayName = 'TextInput'

  public override render() {
    const className = `${styles.textInput} ${this.props.className || ''}`
    const props = { ...this.props, className }
    return <LazyInput__DEPRECATED {...(props as any)} />
  }
}
